import React from 'react'
import { PrimaryBtn, SecondaryBtn, OutlinedBtn } from './styles'
import { logEvent } from '../../Utils/analytics/firAnalytics'

type ActionButtonProps = {
  handleClick: () => void
  btnStyle: 'primary' | 'secondary' | 'outlined'
  disabled?: boolean
  analytics?: { event: string; params?: Record<string, unknown> }
}

export const Btn: React.FC<React.PropsWithChildren<ActionButtonProps>> = ({
  handleClick,
  btnStyle,
  analytics,
  disabled,
  children,
}) => {

  const handleButtonClick = () => {
    handleClick()
    analytics && logEvent(analytics.event, analytics.params)
  }
  return (
    <>
      {btnStyle === 'primary' && (
        <PrimaryBtn onClick={handleButtonClick} disabled={disabled} buttonType={btnStyle}>
          {children}
        </PrimaryBtn>
      )}
      {btnStyle === 'secondary' && (
        <SecondaryBtn onClick={handleButtonClick} disabled={disabled} buttonType={btnStyle}>
          {children}
        </SecondaryBtn>
      )}
      {btnStyle === 'outlined' && (
        <OutlinedBtn onClick={handleButtonClick} disabled={disabled} buttonType={btnStyle}>
          {children}
        </OutlinedBtn>
      )}
    </>
  )
}
